import React from 'react';

import { useSelector } from 'react-redux';
import { selectHazardMetric } from '../../store/options/options.selector';
import {
  selectCountyNames,
  selectEpisodesData,
  selectYear,
} from '../../store/episodes/episodes.selector';

import EpisodeItem from '../episode-item/episode-item.component';

export default function EpisodeItems() {
  const metric = useSelector(selectHazardMetric);
  const countyNames = useSelector(selectCountyNames);
  const episodesData = useSelector(selectEpisodesData);
  const year = useSelector(selectYear);

  return (
    <>
      {episodesData.length ? (
        episodesData.map((episode, i) => (
          <EpisodeItem
            key={i}
            episode={episode}
            metric={metric}
            countyNames={countyNames}
          />
        ))
      ) : (
        <div className='episodes-timeline-none'>
          There were no reported hazard events and/or damages for <b>{year}</b>{' '}
          in this location.
        </div>
      )}
    </>
  );
}
